module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommendBox"
  }, [_c('div', {
    staticClass: "titleBox"
  }, [_c('div', {
    staticClass: "titleInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-star",
      "color": "#FFD700",
      "size": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "titleTxt"
  }, [_vm._v("精品推荐")])], 1)]), _vm._v(" "), (_vm.isShowRecom) ? _c('div', {
    staticClass: "recomBookBox"
  }, [_c('div', {
    staticClass: "recomBook-wrap"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": '/bookdetails/' + _vm.recomArr[0].title + '&' + _vm.recomCatalog
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.recomArr[0].img),
      expression: "recomArr[0].img"
    }],
    staticClass: "recomBookImg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "recomBookInfo"
  }, [_c('p', {
    staticClass: "recomBook-title"
  }, [_vm._v(_vm._s(_vm.recomArr[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-catalog"
  }, [_vm._v("分类：" + _vm._s(_vm.recomArr[0].catalog))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-reading"
  }, [_vm._v("人气：" + _vm._s(_vm.recomArr[0].reading))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-sub2",
    domProps: {
      "innerHTML": _vm._s(_vm.recomArr[0].sub2)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "recomBook-wrap"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": '/bookdetails/' + _vm.recomArr[1].title + '&' + _vm.recomCatalog
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.recomArr[1].img),
      expression: "recomArr[1].img"
    }],
    staticClass: "recomBookImg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "recomBookInfo"
  }, [_c('p', {
    staticClass: "recomBook-title"
  }, [_vm._v(_vm._s(_vm.recomArr[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-catalog"
  }, [_vm._v("分类：" + _vm._s(_vm.recomArr[1].catalog))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-reading"
  }, [_vm._v("人气：" + _vm._s(_vm.recomArr[1].reading))]), _vm._v(" "), _c('p', {
    staticClass: "recomBook-sub2",
    domProps: {
      "innerHTML": _vm._s(_vm.recomArr[1].sub2)
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottomBox"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.changeRecom()
      }
    }
  }, [_vm._v("\n      换一换\n      "), _c('Icon', {
    attrs: {
      "type": "android-refresh",
      "size": "12"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2709fdc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Recommend.vue
// module id = 182
// module chunks = 1